export * from './src/analytics-model-v3-model-analytics-model.universal.js';
